import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../UniformComponents/Modal'
import Button from '../../UniformComponents/Button'
import ModalFooter from '../../UniformComponents/ModalFooter'
import ModalHeader from '../../UniformComponents/ModalHeader'
import Select from '../form/Select'

@observer
class FilterRespondentTypeModal extends Component {
    save = async () => {
        const { dashStore } = this.props
        const { toggleShowFilters, loadFilterData } = dashStore

        await loadFilterData()
        toggleShowFilters()
    }

    render() {
        const { dashStore } = this.props
        const {
            showSelectFilterRespondent, filterSurveys, productMap, filterRespondentType, closeFilterRespondentTypeModal,
        } = dashStore
        const surveysInfo = filterSurveys.map((s) => ({
            respondentType: s.survey.metadata.taxonomy.respondentType,
            surveyType: s.survey.metadata.taxonomy.surveyType,
            industry: s.survey.metadata.productInfo.industrySpecificInfo.industry,
            productType: s.survey.metadata.productInfo.industrySpecificInfo.productType,
        }))

        const respondentTypes = surveysInfo.map((si) => R.pathOr(undefined, [
            si.industry,
            'children',
            si.productType,
            'children',
            si.surveyType,
            'children',
            si.respondentType,
        ], productMap)).filter((rt) => !!rt)

        return (
            <Modal
                show={showSelectFilterRespondent}
                onClose={closeFilterRespondentTypeModal}
                cssClass="createTemplateModal"
            >
                <ModalHeader>
                    <div className="title">
                        <h3>Filter respondent type</h3>
                    </div>
                </ModalHeader>
                <div className="body">
                    <div style={{ marginBottom: '10px' }}>
                        <Select
                            label={i18n.t('respondent_type')}
                            name="filterRespondentType"
                            options={respondentTypes}
                            value={respondentTypes.find((rt) => filterRespondentType === rt.value)}
                            onBlur={dashStore.setFilterRespondent}
                            blurOnClear
                        />
                    </div>
                </div>
                <ModalFooter>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <Button
                            label={(
                                <div>
                                    {i18n.t('cancel')}
                                </div>
                            )}
                            cssClass="tertiary regular"
                            onClick={closeFilterRespondentTypeModal}
                        />
                        <Button
                            label={(
                                <div>
                                    {i18n.t('save')}
                                </div>
                            )}
                            cssClass="primary regular"
                            style={{ width: '200px', fontWeight: 600, textAlign: 'center' }}
                            onClick={this.save}
                            disabled={!dashStore.filterRespondentType}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default FilterRespondentTypeModal
